import ApplyRounding from '../../../../../../../utils/math/ApplyRounding';

export function parseBounceNotificationDetails(notification) {
  const setupString = 'Bounce';
  const triggerPrice = ApplyRounding(
    notification.statusDetails.triggerPrice,
    2
  );
  
  return {
    tactic: setupString,
    price: '$' + triggerPrice,
  };
}
